import BASE_URL from "components/BaseUrl/apiConfig";
import BlockUiOverlay from "components/Expense/BlockUiOverlay";
import Footer from "components/Footers/Footer";
import Navbar from "components/Navbars/AuthNavbar";
import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import Swal from "sweetalert2";

const GetDocumentCategory = () => {
  const history = useHistory();
  const [documentCategory, setDocumentcategory] = useState([]);
  const [loading, setLoading] = useState(false);
  //get groupId form loca storage
  const storedUserData = localStorage.getItem("userData");
  let userId = "";

  if (storedUserData) {
    const userData = JSON.parse(storedUserData);
    userId = userData.userId;
  }

  const fetchItems = async () => {
    setLoading(true);
    fetch(
      `${BASE_URL}/api/DocumentCategory/GetDocumentCategories?UserId=${userId}`
    )
      .then((response) => response.json())
      .then((data) => {
        setDocumentcategory(data);
        console.log(data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchItems();
  }, []);

  const NavigateAddDocumentCategory = () => {
    history.push("/addDocumentCategory");
  };

  const navigateUpdateDocumentCategory = (documentCategory) => {
    // Navigate to the "addexpensetype" page with the expenseType data
    history.push({
      pathname: "/addDocumentCategory",
      state: { documentCategory: documentCategory },
    });
  };

  // Function to handle the view button click
  const handleViewClick = (documentCategory) => {
    // Navigate to the "/expensetypeDetails" page with the expenseType data
    history.push({
      pathname: "/documentCategoryDetails",
      state: { documentCategory: documentCategory },
    });
  };

  const NavigateDocumentCategory = (documentCategory) => {
    // Navigate to the "/expensetypeDetails" page with the expenseType data
    history.push({
      pathname: "/categoryDocuments",
      state: { documentCategory: documentCategory },
    });
  };

  const DeleteDocumentCategory = (documentCategoryId, name) => {
    // Show a SweetAlert confirmation before deleting
    Swal.fire({
      title: "Confirmation",
      text: `Are you sure want to delete ${name} document category type?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes",
    }).then((result) => {
      if (result.isConfirmed) {
        // User clicked "Yes, delete it!" - Perform the delete API call
        fetch(
          `${BASE_URL}/api/DocumentCategory/DeleteDocumentCategory?DocumentCategoryId=${documentCategoryId}`,
          {
            method: "Post",
          }
        )
          .then((response) => response.json())
          .then((data) => {
            if (data.success) {
              fetchItems();
              Swal.fire(
                "Deleted!",
                "Document Category has been deleted successfully.",
                "success"
              );
            } else {
              // Handle delete failure (show error message, etc.)
              Swal.fire(
                "Error!",
                "Document Category deletion failed.",
                "error"
              );
            }
          })
          .catch((error) =>
            console.error("Error deleting Document Category:", error)
          );
      }
    });
  };

  const NavigatedocumentsPage = () => {
    history.push("/getDocument");
  };

  return (
    <>
      <Navbar />
      <BlockUiOverlay visible={loading} />
      <div className="cust-div" style={{ minHeight: "550px" }}>
        <div className="container mx-auto p-4">
          <div className="flex justify-between items-center mb-4">
            <h1 className="text-2xl font-bold">Document Category</h1>
            <div className="flex">
              <button
                onClick={NavigatedocumentsPage}
                className="bg-lightBlue-500 text-white active:bg-lightBlue-600 mr-3 text-xs font-bold uppercase px-4 py-2 rounded shadow hover:shadow-lg outline-none focus:outline-none ease-linear transition-all duration-150"
                type="button"
              >
                <i
                  className="fa fa-arrow-circle-left mr-1"
                  title="Go To Documents"
                ></i>
              </button>
              <button
                onClick={NavigateAddDocumentCategory}
                className="bg-lightBlue-500 text-white active:bg-lightBlue-600 text-xs font-bold uppercase px-4 py-2 rounded shadow hover:shadow-lg outline-none focus:outline-none ease-linear transition-all duration-150"
                type="button"
                title="Add new Document Category"
              >
                Add New
              </button>
            </div>
          </div>
          <div className="overflow-x-auto">
            <table className="w-full min-w-full ">
              <tbody>
                <tr className="border-b bg-lightBlue-500 text-white ">
                  <td className="cell py-2 px-4 font-bold">Category</td>
                  <td className="cell py-2 px-4 font-bold">Default Text</td>
                  <td className="cell py-2 px-4 font-bold"></td>
                  <td
                    className="cell py-2 px-4 font-bold"
                    style={{ float: "inline-end" }}
                  >
                    Actions
                  </td>
                </tr>
                {documentCategory && documentCategory.length > 0 ? (
                  documentCategory.map((documentCategory) => (
                    <tr
                      key={documentCategory.documentCategoryId}
                      className="hover:bg-gray-100 border-b"
                    >
                      <td className="cell py-1 px-4">
                        {documentCategory.name}
                      </td>
                      <td className="cell py-1 px-4">
                        {documentCategory.defaultText}
                      </td>
                      <td className="cell py-1 px-4">
                        <button
                          className="bg-lightBlue-500 text-white active:bg-lightBlue-600 text-xs px-2 py-0 rounded outline-none focus:outline-none ease-linear transition-all duration-150"
                          type="button"
                          title="Total Documents"
                          onClick={() =>
                            NavigateDocumentCategory(documentCategory)
                          }
                        >
                          {documentCategory.totalDocuments}
                        </button>
                      </td>
                      <td className="cell py-1 px-4 flex justify-end">
                        {/* Edit Icon */}
                        <img
                          title="Edit"
                          src={require("assets/img/Editicon.png")}
                          alt="Edit"
                          className="mr-2 cursor-pointer"
                          style={{ width: "20px" }}
                          onClick={() =>
                            navigateUpdateDocumentCategory(documentCategory)
                          }
                        />
                        {/* View Icon */}
                        <img
                          title="View"
                          src={require("assets/img/Viewicon.png")}
                          alt="View"
                          className="mr-2 cursor-pointer"
                          style={{ width: "20px" }}
                          onClick={() => handleViewClick(documentCategory)}
                        />
                        <img
                          title="Delete"
                          src={require("assets/img/deleteicon.png")}
                          alt="Delete"
                          className="cursor-pointer"
                          style={{ width: "20px" }}
                          onClick={() =>
                            DeleteDocumentCategory(
                              documentCategory.documentCategoryId,
                              documentCategory.name
                            )
                          }
                        />
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      className="cell py-2 px-4"
                      colSpan="6"
                      style={{ textAlign: "center" }}
                    >
                      No documents category are available here.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default GetDocumentCategory;
